export enum LinksBlock {
    GENERAL = "generalBlock",
    BRAND = "brandBlock",
    BUTTONS = "buttonsBlock",
    SOCIAL_LINKS = "socialLinksBlock",
    BANNER = "bannerBlock",
    SERVICE = "serviceBlock",
    ZERO = 'zeroBlock'
  }